import { sortBy, toTitleCase, utc } from '@vrplatform/utils';
import type { HasuraClient } from '@vrplatform/graphql';
import { whereOwnerStatements } from '../queries';
import { getStatementSummary } from '../statements';
import { formatOwnerName, getListingName } from '../utils';

export const ownerStatementsListCsvQuery = async (
  client: HasuraClient,
  input: Parameters<typeof whereOwnerStatements>[0]
) => {
  const rows = await client.query((q) => {
    return q
      .ownerStatements({
        where: whereOwnerStatements({ ...input }),
      })
      .map((statement) => {
        const summary = getStatementSummary({
          currency: statement.currency || 'usd',
          centTotal: statement.centTotal,
          centBalanceStart: statement.centBalanceStart,
          centPayedOut: statement.centPayedOut,
          ownerSplit: undefined,
          status: statement.status,
        });

        const owners = statement
          .owners({
            where: {
              newOwnerId: { _is_null: false },
            },
          })
          .map((x) => {
            return formatOwnerName(x.newOwner) || 'missing name';
          });

        return {
          Listing: getListingName(statement.listing),
          Owners: sortBy(owners).join(', '),
          Month: utc(statement.startAt).format('MMMM YYYY'),
          Status:
            statement.status === 'posted'
              ? 'Published & Billed'
              : toTitleCase(statement.status),
          Currency: statement.currency?.toUpperCase() || 'USD',
          'Starting Balance': summary.formatted.startingBalance,
          'Net Income': summary.formatted.netIncome,
          'Current Balance': summary.formatted.currentBalance,
          'Owner Payout': summary.formatted.payout,
          'Ending Balance': summary.formatted.endingBalance,
        };
      });
  });

  return {
    rows: sortBy(rows, 'Listing'),
  };
};
